// Opening a conversation mounts several independent widgets in the same tick
// (Sidebar, ChatList, ContactPanel, ConversationParticipant...), and more than
// one of them dispatches the same read-only Vuex "get/fetch" action for
// account-wide reference data (agents, custom attribute definitions, funnels,
// integrations...). None of those callers know about each other, so without
// this guard the same GET fires twice (or more) in parallel for the same
// open cycle. `dedupeInFlight` coalesces concurrent calls that share a cache
// key into a single underlying promise: the first caller runs `fn`, every
// other caller within the same window awaits that same promise instead of
// issuing its own request. The entry is cleared as soon as the promise
// settles (success or failure), so the next open cycle always fetches fresh.
const inFlight = new Map();

export const dedupeInFlight = (key, fn) => {
  const existing = inFlight.get(key);
  if (existing) {
    return existing;
  }

  const promise = Promise.resolve()
    .then(fn)
    .finally(() => {
      if (inFlight.get(key) === promise) {
        inFlight.delete(key);
      }
    });

  inFlight.set(key, promise);
  return promise;
};
